module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2010-09-18-1.4fe833d8.md";